<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-cell-group>
            <van-cell is-link v-rblink="{name:'ISaiApplyList'}" title="我报名的比赛"  label="以备案单位为主体发起报名参加的啦啦操比赛管理证书下载">
            </van-cell>
            <!-- <van-cell is-link v-rblink="{name:'ISaiApplyFamliyList'}" title="我参与的项目"  label="我作为家长受邀参与报名的啦啦操项目"> -->
            <!-- </van-cell> -->
            <van-cell is-link v-rblink="{name:'ChaIndex'}" title="教练员裁判员优秀证书下载"  label="教练员裁判员优秀证书下载">
            </van-cell>
            <van-cell title="家长认证"  label="上传身份证明信息，完成后自动关联子女运动员信息" v-if="false">
                <template #right-icon>
                    <div class="tiny-btn-1">管理</div>
                </template>
            </van-cell>

            <div class="bottom-button">
                <van-button round type="default" v-rblink="{name:'YundongyuanList'}">运动员注册</van-button>
                <van-button round type="default" v-rblink="{name:'CaipanList'}">裁判员注册</van-button>
                <van-button round type="default" v-rblink="{name:'JiaolianList'}">教练员注册</van-button>
            </div>
            <div style="height: 10px"></div>

            <van-cell is-link v-rblink="{name:'HuiyiApplyList'}" title="我的会议培训"  label="我报名的啦啦操的会议培训" >
                <template #default>
                    <div class="badge" v-if="row.huiyi_count">{{row.huiyi_count}}</div>
                </template>
            </van-cell>
        </van-cell-group>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'MyActivity',
        components: {
            PicUploader,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                loginShow:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{
                    danwei:{

                    }
                },
                formData: {

                },
            }
        },
        filters: {},
        mounted() {
            document.title = "活动";
            let that = this;
            this.fetch();
        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            fetch(){
                let that = this;
                that.$api.post('/api/user/certindex', {
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

        }
    }
</script>



// WEBPACK FOOTER //
// MyActivity.vue?55fcb61d